function intersectionByLens<T>(lens: (a: T, b: T) => boolean) {
  return function intersection(a: T[], b: T[]): T[] {
    return a.filter((aValue) => b.some((bValue) => lens(aValue, bValue)));
  };
}

export default intersectionByLens;
